import { downloadBlob, postForFile } from './batch3Api';

export { downloadBlob };

export type ToaOutput = 'with_metadata' | 'without_metadata' | 'both';

export interface ToaSummary {
  total_sheets: number;
  transformed_sheets: number;
  sheet_names: string[];
  log: string;
}

export interface EspSummary {
  log: string;
}

export function transformOnlineAccountants(file: File, output: ToaOutput) {
  const form = new FormData();
  form.append('input_file', file);
  form.append('options', JSON.stringify({ output }));
  return postForFile<ToaSummary>('/client-transformer/online-accountants', form, 'transformed.xlsx', 'Transformation failed');
}

export function transformAccountProcessing(file: File) {
  const form = new FormData();
  form.append('input_file', file);
  return postForFile<EspSummary>('/client-transformer/account-processing', form, 'processed.xlsx', 'Transformation failed');
}

export function transformEsp(file: File) {
  const form = new FormData();
  form.append('input_file', file);
  return postForFile<EspSummary>('/client-transformer/esp', form, 'transformed.xlsx', 'Transformation failed');
}
